<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.28 102.28">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_4" data-name="Layer 4">
                <circle cx="51.14" cy="51.14" r="51.14" fill="#c6c6c5" />
                <g>
                    <path
                        d="M24.15,27.61H27c1.77,0,3.12.62,3.12,2.51S28.77,32.77,27,32.77H25.65v3.31h-1.5Zm2.7,4c1.16,0,1.79-.48,1.79-1.45s-.63-1.31-1.79-1.31h-1.2v2.76Zm-.13.8,1.09-.9,2.64,4.61H28.77Z"
                        fill="#fff"
                    />
                    <path d="M32.46,27.61h5.1v1.27H34v2.17h3v1.26H34v2.51h3.73v1.26H32.46Z" fill="#fff" />
                    <path
                        d="M40.07,27.61h1.7l1.5,4.14c.18.54.36,1.11.54,1.66h0c.19-.55.35-1.12.54-1.66l1.46-4.14h1.7v8.47H46.19V32.21c0-.79.11-1.91.19-2.7h-.05l-.69,2-1.39,3.81h-.89L42,31.48l-.68-2h-.05c.07.79.19,1.91.19,2.7v3.87H40.07Z"
                        fill="#fff"
                    />
                    <path
                        d="M49.6,35.07l.71-1a2.7,2.7,0,0,0,1.95.9c.9,0,1.52-.47,1.52-1.24s-.54-1.4-2.42-1.4V31.29c1.62,0,2.14-.56,2.14-1.32a1.07,1.07,0,0,0-1.21-1.1,2.38,2.38,0,0,0-1.65.78l-.77-.93a3.63,3.63,0,0,1,2.48-1c1.57,0,2.66.79,2.66,2.18a2,2,0,0,1-1.44,1.9v0a2.08,2.08,0,0,1,1.72,2.05c0,1.5-1.31,2.38-2.9,2.38A3.56,3.56,0,0,1,49.6,35.07Z"
                        fill="#fff"
                    />
                    <path
                        d="M57.65,27.61h2.86c1.76,0,3.12.62,3.12,2.51s-1.36,2.65-3.12,2.65H59.16v3.31H57.65Zm2.7,4c1.16,0,1.79-.48,1.79-1.45s-.63-1.31-1.79-1.31H59.16v2.76Zm-.12.8,1.08-.9L64,36.08H62.27Z"
                        fill="#fff"
                    />
                    <path
                        d="M65.52,31.88c0-2.78,1.73-4.42,3.88-4.42a3.36,3.36,0,0,1,2.44,1.07l-.8,1a2.22,2.22,0,0,0-1.61-.74c-1.38,0-2.37,1.17-2.37,3.07s.91,3.1,2.33,3.1a2.41,2.41,0,0,0,1.81-.87L72,35a3.36,3.36,0,0,1-2.66,1.24C67.21,36.24,65.52,34.68,65.52,31.88Z"
                        fill="#fff"
                    />
                    <path d="M74.06,27.61h1.51V31H79V27.61H80.5v8.47H79V32.33H75.57v3.75H74.06Z" fill="#fff" />
                </g>
                <g>
                    <polygon points="44 66.29 60.29 66.29 60.29 55.72 65.9 55.72 52.13 40.75 38.39 55.72 44 55.72 44 66.29" fill="#fff" />
                    <path
                        d="M67.21,71.4v6.28a2.55,2.55,0,0,1-2.55,2.56H40.37a2.56,2.56,0,0,1-2.55-2.56V71.4H34.44v9.08a3.15,3.15,0,0,0,3.14,3.15H67.45a3.15,3.15,0,0,0,3.15-3.15V71.4Z"
                        fill="#fff"
                    />
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// UploadXlsIcon.vue?09f299c2